export default {
  name: 'color',
  type: 'layout',
  active: false,
  data: {
    color: ''
  }
}
